import {
  ClickableList,
  ClickableListItem,
  Column
} from '@cdab/scania/qpr/components'
import { useCssVariableBreakpoint } from '@cdab/scania/qpr/hooks'
import { removeHtmlTagsFromString } from '@cdab/utils'
import { TdsAccordion, TdsAccordionItem, TdsBadge } from '@scania/tegel-react'
import { useLocation, useNavigate, useRouteLoaderData } from 'react-router'
import styled from 'styled-components'
import type { DashboardLoaderData } from './dashboard'

export const StyledColumn = styled(Column)`
  padding-top: var(--tds-spacing-element-16);
  padding-bottom: var(--tds-spacing-element-16);
`

export function DeviationsFeedback() {
  const isLg = useCssVariableBreakpoint('--tds-grid-lg')
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const { adhAudits } = useRouteLoaderData('dashboard') as DashboardLoaderData

  function onClickDeviation(
    auditId: number,
    auditPointId: number,
    deviationId: number
  ) {
    navigate(`/audit/${auditId}/points/auditpoint/${auditPointId}/deviations`, {
      state: {
        deviationId: deviationId.toString(),
        previousPath: pathname
      }
    })
  }

  return (
    <StyledColumn
      width={12}
      lg={6}
      offset={{ md: 3 }}
      fullHeight
      padding={isLg}
    >
      {adhAudits.map(audit => (
        <div className='tds-mode-variant-primary'>
          <TdsAccordion>
            <TdsAccordionItem header={audit.dealerInfo}>
              <ClickableList>
                {audit.deviations.map(deviation => (
                  <ClickableListItem
                    title={`${
                      deviation.auditPointNo
                    } ${removeHtmlTagsFromString(
                      deviation.auditPointDescription
                    )}`}
                    description={deviation.deviation}
                    rightItem={
                      <TdsBadge value={deviation.countOfMessages.toString()} />
                    }
                    onClick={() =>
                      onClickDeviation(
                        audit.auditId,
                        deviation.auditPointId,
                        deviation.actionPlanItemId
                      )
                    }
                  />
                ))}
              </ClickableList>
            </TdsAccordionItem>
          </TdsAccordion>
        </div>
      ))}
    </StyledColumn>
  )
}
